/**
 * UAVTradeZone Modification Record
 *
 * Change ID:    EXPORT_CONTEXT_PROVIDER
 * Date:         2026-02-08
 * Modified By:  Claude
 *
 * Description:
 * Context provider for sharing export state across components.
 * Wraps the useExportPolling hook so export continues even when
 * navigating away from the inventory page.
 *
 * File Size Check:
 * - Current: ~35 lines
 * - Projected: ~35 lines
 * - Decision: New file
 *
 * Related Files:
 * - client/src/hooks/useExportPolling.ts
 * - client/src/App.tsx
 * - client/src/features/inventory/InventoryPage.tsx
 */

import React, { createContext, useContext, ReactNode } from "react";
import { useExportPolling } from "../hooks/useExportPolling";

interface ExportContextValue {
  isExporting: boolean;
  startExport: (jobId: string) => void;
}

const ExportContext = createContext<ExportContextValue>({
  isExporting: false,
  startExport: () => {},
});

interface ExportProviderProps {
  children: ReactNode;
}

export function ExportProvider({ children }: ExportProviderProps) {
  const exportState = useExportPolling();

  return (
    <ExportContext.Provider value={exportState}>
      {children}
    </ExportContext.Provider>
  );
}

export const useExport = () => useContext(ExportContext);
